import { createSlice } from "@reduxjs/toolkit";
import { extractFeatureFlags } from "../../featureFlags/utils/jwt";

const initialState = {
  user: null,
  token: null,
  userPermissions: null,
  permissionsLoaded: false,
  featureFlags: null,
  permissionBypass: process.env.REACT_APP_PERMISSION_BYPASS === 'true' || false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials(state, action) {
      state.user = action.payload.data;
      state.token = action.payload.access_token;
      // Extract and store feature flags from JWT token
      if (action.payload.access_token) {
        state.featureFlags = extractFeatureFlags(action.payload.access_token);
      }
      // If permissions are included in the response, store them
      if (action.payload.data?.permissions) {
        state.userPermissions = action.payload.data.permissions;
        state.permissionsLoaded = true;
      }
    },
    signOut(state) {
      state.user = null;
      state.token = null;
      state.userPermissions = null;
      state.permissionsLoaded = false;
      state.featureFlags = null;
      // Keep permissionBypass on signout for development purposes
    },
    setCurrentUser(state, action) {
      state.user = action.payload;
      // If permissions are included in the user data, store them
      if (action.payload?.permissions) {
        state.userPermissions = action.payload.permissions;
        state.permissionsLoaded = true;
      }
    },
    setUserPermissions(state, action) {
      state.userPermissions = action.payload;
      state.permissionsLoaded = true;
    },
    setPermissionBypass(state, action) {
      state.permissionBypass = action.payload;
    },
    togglePermissionBypass(state) {
      state.permissionBypass = !state.permissionBypass;
    },
    setFeatureFlags(state, action) {
      state.featureFlags = action.payload;
    },
    refreshFeatureFlags(state) {
      // Re-extract feature flags from current token
      if (state.token) {
        state.featureFlags = extractFeatureFlags(state.token);
      }
    },
  },
});

export const {
  setCredentials,
  signOut,
  setCurrentUser,
  setUserPermissions,
  setPermissionBypass,
  togglePermissionBypass,
  setFeatureFlags,
  refreshFeatureFlags
} = authSlice.actions;

export default authSlice.reducer;
